export default __webpack_public_path__ + "media/complete-missions3x.4e859090.png";